import { render } from "./SectionFrame.vue?vue&type=template&id=0cd5932a"
import script from "./SectionFrame.vue?vue&type=script&lang=js"
export * from "./SectionFrame.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SectionFrame.vue?vue&type=style&index=0&id=0cd5932a&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__